<template>
    <div>
        <v-carousel
            hide-delimiters
            ref="carousel"
            :height="carouselHeight"
            cycle
        >
            <template v-slot:prev="{ on, attrs }">
                <SolidGreenArrows @click="prevSlide" :flip="true" />
            </template>
            <template v-slot:next="{ on, attrs }">
                <SolidGreenArrows @click="nextSlide" />
            </template>
            <div class="">
                <v-carousel-item
                    v-for="(image, index) in carousel"
                    :key="index"
                    :src="($vuetify.breakpoint.mobile) ? '/storage/carousels/' + image.image_mobile : '/storage/carousels/' + image.image_desktop"
                    cover
                >
                    <div class="tw-hidden sm:tw-flex tw-relative tw-px-4 tw-w-full tw-h-full">
                        <div class="tw-absolute tw-bottom-0 tw-left-0 tw-px-2 tw-bg-black tw-text-green-400" v-text="image.image_caption"></div>
                    </div>
                </v-carousel-item>
            </div>

        </v-carousel>
    </div>
</template>

<script>
import SolidGreenArrows from '@/Generic/icons/SolidGreenArrows'

export default {
    components: {
        SolidGreenArrows,
    },
    name: 'HomeCarousel',
    props: {
        carousel: {
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            carouselHeight: '780px', // Default height value
        }
    },
    mounted() {
        window.addEventListener('resize', this.updateCarouselHeight);
        this.updateCarouselHeight();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateCarouselHeight);
    },
    methods: {
        prevSlide() {
            this.$refs.carousel.prev();
        },
        nextSlide() {
            this.$refs.carousel.next();
        },
        updateCarouselHeight() {
            const windowWidth = window.innerWidth;
            if (windowWidth < 400 ) {
                this.carouselHeight = '400px';
            } else if (windowWidth < 600 ) {
                this.carouselHeight = '600px'; //
            } else {
                this.carouselHeight = '780px'; // Default height value for other breakpoints
            }
        },
    },
};
</script>
<style scoped>
a {
    color: #000;
    width: fit-content;
}
</style>
